$(document).ready(function(){
    $('.s-cookie__close').click(function(){
        var cookie = $(this).closest('.s-cookie');
        $.ajax({url: "/ajax/accept-cookies/",});
        cookie.fadeOut();
    });
});